import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';
import { ListEvents } from './graphql.js';
import { updateInPath } from '../../../../common/utils';
import { getList } from '../../../common/utils';
import { clone, find } from 'ramda';

class EventDropdown extends Component {
  constructor(props) {
    super();

    this.state = {
      data: [],
      loading: false,
      filters: {}
    };
  }

  fetchData = async () => {
    const queryProps = { query: ListEvents };

    if (this.props.type) {
      queryProps.variables = { filter: { type: { eq: this.props.type }}};
    }
    
    this.setState(s=> updateInPath(s, 'loading', true));
    const data = await getList('listEvents', queryProps);
    this.setState(s => updateInPath(s, 'data', data));
    this.setState(s=> updateInPath(s, 'loading', false));
  }

  handleEventChange = (e, event) => {
    const item = find(({value}) => value === event.value, event.options);

    this.setState(prevState => {
      const newState = clone(prevState);
      newState.filters.eventId = { eq: event.value };
      // second paramter due to competition view!
      this.props.onSubmit(newState.filters, item);
      return newState;
    });
  };

  componentDidMount = () => {
    this.fetchData();
  }
  
  render() {
    const {
      disabled = false,
      required = false,
      value
    } = this.props;
    
    return (
      <Dropdown
        loading={this.state.loading}
        disabled={disabled}
        selection
        required={required}
        label='Event'
        value={value}
        options={this.state.data}
        onChange={this.handleEventChange}/>
    );
  }
};

export default EventDropdown;



// WEBPACK FOOTER //
// ./src/private/admin/components/EventDropdown/index.js